import { LayerAction, MapToolAction } from '../../enums/mapPortalActions';
import { UserRole } from '../../enums/userEnums';
import { AllowedRoles } from '../../routes/routeConstants/allowedRoles';
import { AccessRequirements } from '../../shared/utils/accessControl';

// From the Map Portal RBAC matrix. Actions left out are open to every role --
// checkAccess reads an undefined allowedRoles as no restriction.
export const LAYER_ACTION_ALLOWED_ROLES: Partial<Record<LayerAction, UserRole[]>> = {
  [LayerAction.DUPLICATE_LAYER]: AllowedRoles.EDITOR_AND_ABOVE,
  [LayerAction.SAVE_LAYER_AS]: AllowedRoles.EDITOR_AND_ABOVE,
  [LayerAction.REMOVE_LAYER]: AllowedRoles.EDITOR_AND_ABOVE,
  [LayerAction.CREATE_GROUP]: AllowedRoles.EDITOR_AND_ABOVE,
  [LayerAction.RE_UPLOAD_DATA]: AllowedRoles.EDITOR_AND_ABOVE,
  [LayerAction.REORDER_LAYERS]: AllowedRoles.EDITOR_AND_ABOVE,
  [LayerAction.MANAGE_GROUPS]: AllowedRoles.EDITOR_AND_ABOVE,
  [LayerAction.SAVE_LAYER]: AllowedRoles.EDITOR_AND_ABOVE,
  [LayerAction.EDIT_LAYER_PROPERTIES]: AllowedRoles.EDITOR_AND_ABOVE,
  [LayerAction.MANAGE_LAYER_PERMISSIONS]: AllowedRoles.EDITOR_AND_ABOVE,
  [LayerAction.OPEN_CREATE_FEATURE]: AllowedRoles.EDITOR_AND_ABOVE,
};

export const layerActionAccess = (action: string): AccessRequirements => ({
  allowedRoles: LAYER_ACTION_ALLOWED_ROLES[action as LayerAction],
});

export const MAP_TOOL_ALLOWED_ROLES: Partial<Record<MapToolAction, UserRole[]>> = {
  [MapToolAction.OPEN_MAP_SETTINGS]: AllowedRoles.EDITOR_AND_ABOVE,
  [MapToolAction.SAVE_TABLE_RESULTS]: AllowedRoles.EDITOR_AND_ABOVE,
};

export const mapToolAccess = (action: string): AccessRequirements => ({
  allowedRoles: MAP_TOOL_ALLOWED_ROLES[action as MapToolAction],
});
